import { render, staticRenderFns } from "./AlertInformation.vue?vue&type=template&id=66625ac8"
import script from "./AlertInformation.vue?vue&type=script&lang=js"
export * from "./AlertInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports